<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Order Store Review</h1>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <!-- <v-text-field
            prepend-icon="search"
            label="Search"
            hide-details
          ></v-text-field
        > -->
        </v-flex>
        <v-flex xs12 sm6 class="px-1">
          <!-- <v-select
            prepend-icon="filter_alt"
            item-value="users.user_info"
            item-text="users.users_name"
            :items="riderList"
            label="Rider"
            v-model="filterBy.rider_id"
            @change="getReviewList()"
          ></v-select
        > -->
        </v-flex>
        <v-flex xs12 sm3 class="px-1">
          <v-autocomplete
            prepend-icon="filter_alt"
            :items="storeList"
            item-text="store_name_th"
            item-value="store_id"
            label="Store"
            v-model="filterBy.store_id"
            @change="
              currentPage = 1;
              getReviewList();
            "
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm3 class="px-1">
          <v-select
            prepend-icon="filter_alt"
            :items="[
              { name: 'Food Delivery', value: 1 },
              { name: 'Messenger', value: 2 },
            ]"
            item-text="name"
            item-value="value"
            label="Order type"
            v-model="filterBy.order_type"
            @change="
              currentPage = 1;
              getReviewList();
            "
            clearable
          ></v-select
        ></v-flex>
        <v-flex xs12 sm3 class="px-1">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                clearable
                label="Order date start"
                persistent-hint
                prepend-icon="event"
                v-on="on"
                v-model="filterBy.date_stat"
                @input="
                  currentPage = 1;
                  getReviewList();
                "
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              @input="
                filterBy.date_stat = $event;
                menu1 = false;
                getReviewList();
              "
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-1">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                clearable
                label="Order date end"
                persistent-hint
                prepend-icon="event"
                v-on="on"
                v-model="filterBy.date_end"
                @input="
                  currentPage = 1;
                  getReviewList();
                "
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              @input="
                filterBy.date_end = $event;
                menu2 = false;
                currentPage = 1;
                getReviewList();
              "
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-data-table
        style="border: 1px solid black"
        hide-actions
        :headers="headers"
        :items="reviewList"
        :loading="isLoadingReview"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">
              {{ props.item.order_review_order_code }}
            </td>
            <td class="text-xs-center">
              {{ props.item.order_review_store_name_th || "(Messenger order)" }}
            </td>
            <td class="text-xs-center">
              {{ props.item.order_review_customer_name }}
            </td>
            <td class="text-xs-center">
              {{ props.item.order_review_rider_name }}
            </td>

            <td class="text-xs-center">
              {{ props.item.order_review_score }}
            </td>
            <td class="text-xs-center">
              {{ props.item.order_review_coment }}
            </td>
            <td class="text-xs-center">
              {{ props.item.order_review_order_time_start }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-pagination
        v-model="currentPage"
        :length="Math.ceil(totalItems / 10)"
        class="mt-3"
        @input="getReviewList()"
      ></v-pagination>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      menu1: false,
      menu2: false,
      headers: [
        {
          text: "Order code",
          align: "center",
          value: "order_review_order_code",
          sortable: false,
        },
        {
          text: "Store name",
          align: "center",
          value: "order_review_store_name_th",
          sortable: false,
        },
        {
          text: "Customer name",
          align: "center",
          value: "order_review_customer_name",
          sortable: false,
        },
        {
          text: "Rider name",
          align: "center",
          value: "order_review_rider_name",
          sortable: false,
        },
        {
          text: "Rating",
          align: "center",
          value: "order_review_score",
          sortable: false,
        },

        {
          text: "Message",
          align: "center",
          value: "order_review_coment",
          sortable: false,
        },
        {
          text: "Order start date",
          align: "center",
          value: "order_review_order_time_start",
          sortable: false,
        },
      ],
      reviewList: [],
      storeList: [],
      riderList: [],
      isLoadingStoreList: false,
      isLoadingReview: false,
      isLoadingRiderList: false,
      filterBy: {
        store_id: null,
        rider_id: null,
        order_type: null,
        date_stat: null,
        date_end: null,
      },
      currentPage: 1,
      totalItems: 0,
    };
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      fetchStoreList: "fetchStoreBack/getStoreList",
      fetchRiderList: "fetchRiderListBack/getRiderList",
      fetchReviewList: "fetchStoreBack/fetchReviewList",
    }),
    async getStoreList() {
      this.isLoadingStoreList = true;
      let result = await this.fetchStoreList();

      if (result !== 3) {
        this.storeList = result;
      }
      this.isLoadingStoreList = false;
    },
    async getRiderList() {
      this.isLoadingRiderList = true;
      this.riderList = await this.fetchRiderList();
      this.isLoadingRiderList = false;
    },
    async getReviewList() {
      this.isLoadingReview = true;
      let payload = {
        querys: {
          order_id: null,
          store_id: this.filterBy.store_id,
          rider_id: this.filterBy.rider_id,
          order_type: this.filterBy.order_type,
          order_start_date: this.filterBy.date_stat,
          order_end_date: this.filterBy.date_end,
          page_size: 10,
          current_page: this.currentPage,
        },
        province: this.$route.params.province,
      };
      let result = await this.fetchReviewList(payload);
      if (result != false) {
        this.reviewList = result.data;
        this.totalItems = result.length;
      }
      this.isLoadingReview = false;
    },
    init() {
      this.getStoreList();
      this.getRiderList();
      this.getReviewList();
    },
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Order Review",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style>
</style>
